import * as React from 'react'
import { useMemo } from 'react'
import { CheckCircle, Loader2, Trash2Icon, XCircle } from 'lucide-react'

import { Button } from '@/components/ui/button.tsx'
import { useFileUpload } from '@/components/ui/extension/file-upload.tsx'
import { Label } from '@/components/ui/label.tsx'
import { Progress } from '@/components/ui/progress.tsx'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select.tsx'
import { useFindAttributeGroups } from '@/features/attribute-groups/hooks/use-find-attribute-groups.ts'
import { UploadingFile } from '@/routes/_authenticated/documents/upload/-components/types.ts'

export const DocumentUploadItem: React.FC<{
  uploadingFile: UploadingFile
  index: number
  onChange?: (file: UploadingFile) => void
}> = ({ uploadingFile, index, onChange }) => {
  const { removeFileFromSet } = useFileUpload()
  const findAttributeGroupsQuery = useFindAttributeGroups()
  const attributeGroups = findAttributeGroupsQuery?.data?.data

  const statusText = useMemo(() => {
    const dict: Record<UploadingFile['status'], string> = {
      idle: 'In attesa',
      uploading: 'Caricamento in corso',
      uploaded: 'Caricato',
      processing: 'In elaborazione',
      error: 'Errore',
    }

    return dict[uploadingFile.status]
  }, [uploadingFile.status])

  return (
    <div className="w-full rounded-md border p-4">
      <div className="mb-2 flex items-center justify-between">
        <p className="font-semibold">{uploadingFile.file.name}</p>

        <Button
          variant="link"
          size="icon"
          className="size-auto p-0 text-sm"
          onClick={() => removeFileFromSet(index)}
        >
          <Trash2Icon />
        </Button>
      </div>
      <Progress value={uploadingFile.progress} className="my-2" />
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-x-1 text-sm capitalize text-gray-500">
          {uploadingFile.status === 'uploading' && (
            <Loader2 className="size-4 animate-spin" />
          )}
          {uploadingFile.status === 'processing' && (
            <Loader2 className="size-4 animate-spin" />
          )}
          {uploadingFile.status === 'uploaded' && (
            <CheckCircle className="size-4 text-green-500" />
          )}
          {uploadingFile.status === 'error' && (
            <XCircle className="size-4 text-red-500" />
          )}

          {statusText}
        </div>

        {/*<Button variant="link" className="h-auto p-0 text-sm text-blue-500">*/}
        {/*  View Document*/}
        {/*</Button>*/}

        <div className="flex basis-7/12 items-center gap-x-2">
          <Label className="text-nowrap">Gruppo Attributi:</Label>
          <Select
            onValueChange={(attributeGroupId) =>
              onChange?.({ ...uploadingFile, attributeGroupId })
            }
          >
            <SelectTrigger>
              <SelectValue placeholder="" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                {attributeGroups?.map((ag) => (
                  <SelectItem value={ag.id} key={ag.id}>
                    {ag.name}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  )
}
